import { createSelector } from 'reselect'
import { IStore } from '../../index'

export function getEventsAreLoading(state: IStore): boolean {
  return state.events.request.events.isLoading
}

export function getRoomsAreLoading(state: IStore): boolean {
  return state.bookingCalendar.request.rooms.isLoading
}

export function getIsLoading(state: IStore) {
  return !state.bookingCalendar.request.isCalendarReady
}

export function getEventsErrorMessage(state: IStore): string {
  return state.events.request.events.errMessage
}

export function getRoomsErrorMessage(state: IStore): string {
  return state.bookingCalendar.request.rooms.errMessage
}

export function isEventsAccepted(state: IStore): boolean {
  return state.events.request.events.acceptedCount > 0
}

export const getErrMessage = createSelector(
  [getEventsErrorMessage, getRoomsErrorMessage],
  (evErr, rErr) => (evErr !== '' ? evErr : rErr !== '' ? rErr : ''),
)
